theme.cart = {
  getCart() {
    const url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());

    return fetch(url, {
      credentials: 'same-origin',
      method: 'GET',
    }).then((response) => response.json());
  },

  changeItem(key, qty, item) {
    return this.updateCart({
      url: ''.concat(theme.routes.cart_change, '?t=').concat(Date.now()),
      data: JSON.stringify({
        id: `${key}`,
        quantity: qty,
      }),
      item,
      qty,
    });
  },

  removeItems(itemsArr) {
    const updates = itemsArr.reduce((acc, curr) => ({...acc, [curr]: 0}), {});

    return this.updateCart({
      url: ''.concat(theme.routes.cart_update, '?t=').concat(Date.now()),
      data: JSON.stringify({updates}),
    });
  },

  updateItem(itemsArr, qty) {
    const updates = itemsArr.reduce((acc, curr) => ({...acc, [curr.key]: qty}), {});

    return this.updateCart({
      url: ''.concat(theme.routes.cart_update, '?t=').concat(Date.now()),
      data: JSON.stringify({updates}),
      item: itemsArr,
      qty
    });
  },

  updateCart(params) {
    return fetch(params.url, {
      method: 'POST',
      body: params.data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        if (params.qty === 0) {
          document.dispatchEvent(
            new CustomEvent('cart:removed', {
              detail: {
                product: params.item,
              },
            })
          );
        }
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              cart,
            },
          })
        );
        return cart;
      });
  },

  addItem(e, button) {
    e.preventDefault();

    if (button.closest('.klaviyo-bis-trigger')) return;

    button.classList.add('skeleton-wave');

    const form = button.closest('form');
    let data;
    let quantity = 1;

    if (form) {
      // add item from the form on product page
      data = theme.utils.serialize(form);
      quantity = 1;
    } else {
      const productId = button.getAttribute('data-product-id');
      data = `id=${productId}&quantity=1`;
    }

    fetch(theme.routes.cart_add, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((product) => {
        document.dispatchEvent(
          new CustomEvent('cart:added', {
            detail: {
              product,
              quantity,
            },
          })
        );
        theme.cart.updateAjaxCart().then(() => {
          window.Modals.cart.open();
          button.classList.remove('skeleton-wave');
        });
      });
  },

  addStarterSet(startersetProducts, button) {
    button.classList.add('skeleton-wave');

    const url = ''.concat(theme.routes.cart_add, '?t=').concat(Date.now());

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: startersetProducts,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        theme.cart.updateAjaxCart().then(() => {
          window.Modals.cart.open();
          button.classList.remove('skeleton-wave');
        });
      });
  },

  updateAjaxCart: async (cart = null) => {
    if (!cart) {
      await fetch('/cart.json')
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: data,
              },
            })
          );
        });
    }

    // Open cart modal if url param is found
    const url = new URL(window.location.href);
    if (url.searchParams.has('cart')) {
      window.Modals.cart.open();
    }
  },
};

export default theme.cart;
